export var BankName;
(function (BankName) {
    BankName["BAGAGE22"] = "Bank of Georgia";
    BankName["TBCBGE22"] = "TBC Bank";
    BankName["JSCRGE22"] = "Credo Bank";
    BankName["ISBKGE22"] = "Isbank Georgia";
    BankName["PAHAGE22"] = "PASHA Bank Georgia";
    BankName["HABGGE22"] = "Halyk Bank Georgia";
    BankName["DISNGE22"] = "Silk Bank";
    BankName["MIBGGE22"] = "ProCredit Bank";
    BankName["TCZBGE22"] = "Ziraat Bank Georgia";
    BankName["CRTUGE22"] = "Cartu Bank";
    BankName["CBASGE22"] = "Basisbank";
    BankName["LBRTGE22"] = "Liberty Bank";
    BankName["TEBAGE22"] = "TeraBank";
    BankName["BZENLT22"] = "ZEN";
})(BankName || (BankName = {}));
//# sourceMappingURL=bank-name.enum.js.map